var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"info-bar",staticStyle:{"position":"relative","z-index":"1"}},[_c('div',{staticClass:"hero is-dark"},[_c('div',{staticClass:"hero-body",staticStyle:{"background-color":"black"}},[_c('div',{staticClass:"container"},[_c('h1',{staticClass:"title"}),_c('h2',{staticClass:"subtitle"})])])])])
}]

export { render, staticRenderFns }